module.exports = __webpack_public_path__ + "static/media/ff_users.ea35eac5.png";